import { Alert, AlertTitle, Button, DialogContent, Grid } from "@mui/material";
import { APICompsSchema } from "@unit/apis";
import { CustomMuiButton } from "@unit/styles";
import { formatSnsTitle } from "@unit/utility";
import { useRouter } from "next/router";
import React from "react";

import { editSnsAccountPath } from "@/global-state/influencer-app-path";

type Props = {
  prMethodType?: APICompsSchema["PRMethodTypeEnum"];
};

const SnsAccountsSettingPane: React.FC<Props> = (props) => {
  const router = useRouter();

  const message = props.prMethodType
    ? {
        title: <strong>アカウント情報を設定してください</strong>,
        body: (
          <>
            このチケットに応募するためには{formatSnsTitle(props.prMethodType)}アカウントの設定が必須です、
            <br />
            マイページから{formatSnsTitle(props.prMethodType)}アカウントの設定をお願いします。
          </>
        ),
      }
    : {
        title: <strong>SNSアカウントを設定してください</strong>,
        body: (
          <>
            <strong>
              チケットに応募される前に、
              <br />
              マイページにて１つ以上のSNSアカウントの連携設定をお願いします。
            </strong>
            <br />
            情報を入力することで採用されやすくなります。
          </>
        ),
      };

  return (
    <DialogContent>
      <Grid item xs={12} pb={2}>
        <Alert severity="warning">
          <AlertTitle>{message.title}</AlertTitle>
          ユニットをご利用いただきありがとうございます。
          <br />
          {message.body}
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <Button
          css={CustomMuiButton}
          type="submit"
          fullWidth
          variant="contained"
          size={"large"}
          onClick={() => router.push(editSnsAccountPath)}
        >
          SNSアカウント登録ページへ
        </Button>
      </Grid>
    </DialogContent>
  );
};
export default React.memo(SnsAccountsSettingPane);
